import moment from 'moment';
import { MetricDto } from '@/core';
import { EChartOption } from 'echarts';
import { getDefaultOptions } from './getDefaultOptions';
import { GroupedMetricType, getGroupedMetrics } from './getGroupedMetrics';
import { displayCurrency } from '@/utils/displayCurrency';

const tooltipFormatter = (param: EChartOption.Tooltip.Format[]) => {
  const valuesData = param
    .map(
      ({ marker, seriesName, data }) => `
        <div class="echarts-tooltip-content-cost">
          <div>${marker}
            <span>${seriesName}</span>
          </div>
          <div class="echarts-tooltip-value">$${displayCurrency(data.at(1))}</div>
        </div>`,
    )
    .join('');

  return `<div>
          ${moment(param[0].axisValue).format('MMMM, YYYY')}
        </div>
        <div class="echarts-tooltip-content">
         ${valuesData}
        </div>`;
};

const getLegend = (legendData: string[]) => ({
  type: 'scroll',
  selectedMode: true,
  padding: [0, 16],
  bottom: 16,
  itemWidth: 8,
  itemHeight: 8,
  textStyle: {
    fontSize: 12,
  },
  itemGap: 24,
  icon: 'circle',
  data: legendData,
});

const getSeries = (metricsGroupedByName: GroupedMetricType[]) =>
  metricsGroupedByName.map(([name, array], index) => ({
    name,
    data: array.map(({ totalCost, month }) => [month, totalCost]),
    type: 'line',
    symbol: 'circle',
  }));

export const getOptionsProductsChart = (maxShownColumns: number, metricsData?: MetricDto[]) => {
  if (!metricsData) return;

  const { metricsGroupedByMonth, metricsGroupedByName } = getGroupedMetrics(metricsData);
  const legendData = metricsGroupedByName.map(([name]) => name);

  const isChartExpanded = metricsGroupedByMonth?.length > maxShownColumns;

  const defaultOptions = getDefaultOptions(isChartExpanded, maxShownColumns);

  const options = {
    ...defaultOptions,
    tooltip: {
      trigger: 'axis',
      className: 'echarts-tooltip',
      formatter: tooltipFormatter,
    },
    yAxis: {
      type: 'log',
      axisLabel: {
        formatter: (value: number) => (value ? `$${value / 1000}K` : value),
      },
    },
    series: getSeries(metricsGroupedByName),
    legend: getLegend(legendData),
  };

  return { options, isChartExpanded };
};
